module.exports = __webpack_public_path__ + "static/media/buildingConstruction20.2fa8e61c.jpg";